import React, { useState, useEffect, useContext, useRef } from "react";

import { Row, Col, Image, Modal } from "react-bootstrap";
import TabsLucrare from "../tabs_lucrare/TabsLucrare";
import {
  deleteDomeniuDocument,
  deleteFolderDomeniu,
  getDomeniuDocumentFolderNames,
  uploadDomeniuDocument,
} from "../backend/FileUploadService";
import { useLocation } from "react-router-dom";
import { RefreshContext } from "../context/RefreshContext";
import logo_image from "../imgs/logo.png";
import ConfirmActionComponent from "./basic/ConfirmActionComponent";
import ModalComponent from "./basic/ModalComponent";
import DocumentDomeniuItem from "./DomeniuFolderItem";
import folder from "../imgs/create-folder-no-back.png";
import ModalFolderDomeniuCreate from "./ModalFolderDomeniuCreate";
import DomeniuFolderItem from "./DomeniuFolderItem";

const DocumenteDomeniuFoldereViewer = () => {
  const [documentsNames, setDocumentsNames] = useState([]);
  const [triggerLucrari, setTriggerLucrari] = useState(false);
  const [activeTab, setActiveTab] = useState("locatie");
  const location = useLocation();
  const {
    internet,
    serverError,
    triggerFoldereDomeniu,
    refreshFoldereDomeniu,
  } = useContext(RefreshContext);
  const [responseReceived, setResponseReceived] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState();
  const [error, setError] = useState();
  const hiddenDocumentInput = useRef(null);
  const [showModalFolderDomeniuCreate, setShowModalFolderDomeniuCreate] =
    useState(false);

  //prop trimise prin history.push
  const { locationType, currentLucrare } = location.state;
  const setTab = (value) => {
    setActiveTab(value);
  };

  const refreshLucrari = () => {
    setTriggerLucrari(!triggerLucrari);
  };

  const chooseDocumentToUpload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    hiddenDocumentInput.current?.click();
  };

  const getDocumentNames = async () => {
    try {
      const result = await getDomeniuDocumentFolderNames(
        locationType.toLowerCase(),
      );
      setDocumentsNames(result);
      setResponseReceived(true);
    } catch (err) {
      setError("Eroare la preluarea documentelor", err);
    }
  };

  useEffect(() => {
    getDocumentNames();
  }, [triggerFoldereDomeniu]);

  const deleteFolder = async () => {
    try {
      await deleteFolderDomeniu(locationType.toLowerCase(), documentToDelete);
      refreshFoldereDomeniu();
      setDocumentToDelete(null);
    } catch (err) {
      setDocumentToDelete(null);
      setError("Eroare la stergerea folderului!");
    }
  };

  const handleUploadDocument = async (event) => {
    try {
      const fileToUpload = event.target.files[0];
      if (!fileToUpload) return;

      const formData = new FormData();
      formData.append("file", fileToUpload);
      await uploadDomeniuDocument(formData, locationType.toLowerCase());

      event.target.value = "";
      refreshFoldereDomeniu();
    } catch (err) {
      setError("Eroare la atasarea documentelor.");
    }
  };

  const closeModalFolderDomeniuCreate = () => {
    setShowModalFolderDomeniuCreate(false);
  };

  return (
    <Row>
      {documentToDelete != null && (
        <ConfirmActionComponent
          buttonIsPressed={true}
          showButtons={false}
          yesPressAction={deleteFolder}
          noPressAction={() => setDocumentToDelete(null)}
          text={`Esti sigur ca vrei sa stergi folderul?`}
        />
      )}
      <>
        {error && (
          <ModalComponent
            size={error ? "sm" : "md"}
            show={error !== null}
            close={() => setError()}
            body={<h3 style={{ color: "red" }}>{error}</h3>}
          />
        )}
      </>
      <Col md={9}>
        {internet && !serverError ? (
          <>
            <Row className={"mb-3"}>
              <div className="headerWrapper">
                <div className="lucrari_cu_fisiere_header">
                  <h2>Documentatii {locationType}</h2>
                </div>
                <div
                  style={{
                    width: "60%",
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <div
                    className="d-inline-block mr-2 locatie_istoric_and_gallery_button"
                    onClick={() => setShowModalFolderDomeniuCreate(true)}
                  >
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUploadDocument}
                      ref={hiddenDocumentInput}
                    />
                    <img
                      src={folder}
                      alt="photos"
                      style={{ maxHeight: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </Row>
            <Row className="middleScreen">
              <Col>
                {documentsNames.length === 0 && responseReceived === true && (
                  <div className="lucrari_not_found">
                    Nu exista documente pentru aceast domeniu.
                  </div>
                )}

                {documentsNames.map((documentData, index) => (
                  <DomeniuFolderItem
                    key={index}
                    folderName={documentData}
                    locationType={locationType}
                    setFolderToDelete={setDocumentToDelete}
                  />
                ))}
              </Col>
            </Row>
          </>
        ) : (
          <div className="no_internet_wrapper">
            <Image src={logo_image} />
            <div className="no_internet_text">
              {serverError
                ? `Nu este conexiune la server`
                : `Nu este conexiune la internet`}
            </div>
          </div>
        )}
      </Col>
      <Col
        md={3}
        className="lineRightDashboard"
        style={{ marginRight: "0px", paddingRight: "0px" }}
      >
        <TabsLucrare
          locationType={location?.state?.locationType}
          currentLucrare={currentLucrare}
          activeTab={activeTab}
          setTab={setTab}
          refreshLucrari={refreshLucrari}
          locatieName={location && location.state && location.state.locatieName}
          locatieId={location && location.state && location.state.locatieId}
        />
      </Col>
      <ModalComponent
        size={"md"}
        show={showModalFolderDomeniuCreate}
        close={closeModalFolderDomeniuCreate}
        headingText={"Creare folder domeniu"}
        body={
          <ModalFolderDomeniuCreate
            locationType={locationType.toLowerCase()}
            closeModal={closeModalFolderDomeniuCreate}
            refreshFoldereDomeniu={refreshFoldereDomeniu}
          />
        }
      />
    </Row>
  );
};
export default DocumenteDomeniuFoldereViewer;
